<template>
  <div class="input-parent">
    <input
      v-model="searchValue"
      class="input-parent__input"
      :placeholder="message || $t('GLOBAL.FORM.SEARCH')"
      type="text"
      @input="handleSearch"
    />

    <img
      :alt="$t('GLOBAL.FORM.SEARCH')"
      class="input-parent__icon"
      src="@/assets/images/components/inputs/search.svg"
      :title="$t('GLOBAL.FORM.SEARCH')"
    />
  </div>
</template>

<script>
  export default {
    name: 'SearchInput',
    props: {
      message: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
    },
    emits: ['onSearch'],
    data() {
      return {
        searchValue: '',
      };
    },
    watch: {
      value: {
        handler(v) {
          this.searchValue = v;
        },
        immediate: true,
      },
    },
    methods: {
      handleSearch() {
        this.$emit('onSearch', this.searchValue);
      },
    },
  };
</script>

<style lang="scss" scoped>
.input-parent {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: var(--mainRadius);
  border: 1px solid var(--gray100);
  background-color: var(--shadesWhite);
  height: 49px;

  &__input {
    border: 0;
    outline: 0;
    width: 100%;
    height: 49px;
    padding: 16px;
    color: var(--gray300);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    display: flex;
    align-items: center;

    &::placeholder {
      color: var(--gray300);
    }
  }

  &__icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
  }
}

.v-locale--is-rtl {
  .input-parent__icon {
    right: unset;
    left: 16px;
  }
}
</style>
